import { Table, Tag, Tooltip, Progress } from "antd";
import DetalleTable from "./DetalleTable";
import { useState } from "react";
import { getDetalleProducto } from "../../../../services/financiero/productosEntregasService";

// 🔥 Helpers corregidos (2 decimales SIEMPRE)
const formatNumber = (value) => {
  if (value === null || value === undefined) return "0.00";
  return Number(value).toLocaleString("es-CO", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

const formatCurrency = (value) => {
  if (value === null || value === undefined) return "$ 0.00";
  return Number(value).toLocaleString("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

export default function ProductosTable({ data }) {
  const [detalles, setDetalles] = useState({});

  // 🔥 CLAVE ÚNICA
  const getKey = (r) =>
    `${r.Numero_PO}_${r.oid_municipio}_${r.oid_proyecto}_${r.observacion}`;

  // 🔥 EXPAND
  const handleExpand = async (expanded, record) => {
    const key = getKey(record);

    if (
      !record.Numero_PO ||
      record.Numero_PO === "Sin PO" ||
      record.oid_municipio == null ||
      record.oid_proyecto == null
    ) {
      console.warn("Registro sin detalle válido:", record);
      return;
    }

    if (expanded && !detalles[key]) {
      try {
        const res = await getDetalleProducto({
          Numero_PO: record.Numero_PO,
          oid_municipio: record.oid_municipio,
          oid_proyecto: record.oid_proyecto,
          observacion: record.observacion
        });

        setDetalles(prev => ({
          ...prev,
          [key]: res
        }));
      } catch (error) {
        console.error("Error cargando detalle:", error);
      }
    }
  };

  const columns = [
    {
      title: "PO",
      dataIndex: "Numero_PO",
      width: 120
    },
    {
      title: "Municipio",
      dataIndex: "municipio",
      width: 160
    },
    {
      title: "Proyecto",
      dataIndex: "nombre_proyecto",
      width: 280,
      render: (text) => (
        <Tooltip title={text}>
          <div
            style={{
              maxWidth: 260,
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: "1.2em"
            }}
          >
            {text}
          </div>
        </Tooltip>
      )
    },
    {
      title: "Cantidad",
      dataIndex: "cantidad_total",
      width: 120,
      render: formatNumber
    },
    {
      title: "Valor Total",
      dataIndex: "valor_total",
      width: 160,
      render: (v) => (
        <span style={{ fontWeight: 600 }}>
          {formatCurrency(v)}
        </span>
      )
    },
    {
      title: "Entregado",
      dataIndex: "cantidad_entregada",
      width: 130,
      render: formatNumber
    },
    {
      title: "Pendiente",
      dataIndex: "pendiente",
      width: 130,
      render: formatNumber
    },
   {
  title: "% Entrega",
  width: 180,
  render: (_, r) => {
    let percent = Number(r.porcentaje_entrega) || 0;

    percent = Math.min(percent, 100);

    // 🎨 colores tipo semáforo
    let color = "#ff4d4f"; // rojo
    if (percent === 100) color = "#52c41a"; // verde
    else if (percent >= 50) color = "#faad14"; // amarillo

    return (
      <Progress
        percent={percent}
        size="small"
        strokeColor={color}
        format={() => {
          if (percent === 100) return "100%";
          return `${percent.toFixed(2)}%`;
        }}
        status="normal"
      />
    );
  }
},
    {
      title: "Estado",
      width: 140,
      render: (_, r) => {
        const p = Number(r.porcentaje_entrega) || 0;

        if (p >= 99.99) return <Tag color="green">Entregado</Tag>;
        if (p === 0) return <Tag color="red">Sin entregas</Tag>;
        return <Tag color="orange">Parcial</Tag>;
      }
    }
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      rowKey={(r) => getKey(r)}
      scroll={{ x: 1100 }}
      expandable={{
        expandedRowRender: (record) => {
          const key = getKey(record);
          return <DetalleTable data={detalles[key] || []} />;
        },
        onExpand: handleExpand,
        rowExpandable: (record) =>
          record.Numero_PO &&
          record.Numero_PO !== "Sin PO" &&
          record.oid_municipio != null &&
          record.oid_proyecto != null
      }}
    />
  );
}